import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddSupportType from "./AddSupportType";
import EditSupportType from "./EditSupportType";
import DeleteSupportType from "./DeleteSupportType";
import SupportTypeViewModel from "../SupportType/SupportTypeViewModel";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class SupportType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showsupportTypeAddModel: false,
      showsupportTypeEditModel: false,
      showsupportTypeDelModel: false,
      SupportTypeViewShow: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.supportTypelist();
    // console.log(this.props.supportTypeList);
  }
  handleAddSupportType = () => {
    this.setState({
      showsupportTypeAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showsupportTypeAddModel: false,
    });
  };
  handleEditSupportType = (item) => {
    this.setState({
      showsupportTypeEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showsupportTypeEditModel: false,
    });
  };
  handleDelSupportType = (item) => {
    this.setState({
      showsupportTypeDelModel: true,
      DeletesupportTypeItem: item,
    });
  };
  closesupportTypeDelModel = () => {
    this.setState({
      showsupportTypeDelModel: false,
    });
  };
  handleSupportTypeView = (item) => {
    this.setState({
      SupportTypeViewShow: true,
      SupportTypeDtls: item,
    });
  };

  handleCloseSupportType = () => {
    this.setState({ SupportTypeViewShow: false });
  };
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.SupportTypeSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.supportTypeCount && this.props.supportTypeCount;
    let SupportTypePageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Support Types</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddSupportType()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddSupportType
                showsupportTypeAddModel={this.state.showsupportTypeAddModel}
                closeAddModel={this.closeAddModel}
                AddSupportType={this.props.AddSupportType}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "10px" }}>SL NO</th>
                    <th style={{ width: "100px" }}>NAME</th>
                    <th style={{ width: "150px" }}>DESCRIPTION</th>
                    <th style={{ width: "50px" }}>ACTIVE</th>
                    <th style={{ width: "50px" }}>CREATED DATE</th>
                    <th style={{ width: "50px" }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.supportTypeList &&
                    this.props.supportTypeList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.supportType}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.disc}
                        </td>

                        <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleSupportTypeView({
                                  item: item,
                                })
                              }
                            ></i>
                            <SupportTypeViewModel
                              show={this.state.SupportTypeViewShow}
                              handleClose={this.handleCloseSupportType}
                              SupportTypeDtls={this.state.SupportTypeDtls}
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditSupportType(item)}
                            ></i>
                            <EditSupportType
                              showsupportTypeEditModel={
                                this.state.showsupportTypeEditModel
                              }
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditSupportType={this.props.EditSupportType}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelSupportType(item)}
                            ></i>
                            <DeleteSupportType
                              showsupportTypeDelModel={
                                this.state.showsupportTypeDelModel
                              }
                              closesupportTypeDelModel={
                                this.closesupportTypeDelModel
                              }
                              DeletesupportTypeItem={
                                this.state.DeletesupportTypeItem
                              }
                              DeleteSupportType={this.props.DeleteSupportType}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.supportTypeList === undefined ||
                (this.props.supportTypeList &&
                  this.props.supportTypeList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Support Type Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {SupportTypePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={SupportTypePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default SupportType;
